/**
 * Centralized Tier Pricing Fallbacks
 *
 * Single source of truth for fallback prices used when the backend API is
 * unreachable. Every file that needs a price fallback MUST import from here
 * instead of hardcoding a number.
 *
 * Actual prices are managed via admin dashboard and served by the API.
 * These values are ONLY used as a last-resort fallback.
 *
 * Keep in sync with: workers/src/config/tierConfiguration.ts
 */

export const FALLBACK_PRICES = {
  FREE: 0,
  PROFESSIONAL: 149000,
  ENTERPRISE: 299000,
} as const;

/** Get fallback price by tier id (case-insensitive). Returns 0 for unknown tiers. */
export function getFallbackPrice(tierId: string): number {
  const key = tierId.toUpperCase() as keyof typeof FALLBACK_PRICES;
  return FALLBACK_PRICES[key] ?? 0;
}
